var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"dot",style:(("height: " + _vm.size + "px; width: " + _vm.size + "px"))})}
var staticRenderFns = []

export { render, staticRenderFns }